'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialDropboxOutline = function IoSocialDropboxOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.8 6l6.2 5.2-8.9 5.5-6.1-4.9z m-6.7 6l4.1 3.2 6.7-4.1-4.1-3.6z m21.8 4.6l6.1 5-6.1 3.9v3.1l-8.9 5.4-8.9-5.3v-3.1l-6.1-4 6.1-5 8.9 5.6-6.2 5.1-1.5-0.9v1.6l7.7 4.6 7.7-4.6v-1.6l-1.5 0.9-6.2-5.1z m-17.7 1.4l-4.1 3.5 6.7 4.3 4.1-3.5z m10.9 4.3l4.1 3.5 6.7-4.4-4.1-3.4z m12.9-10.5l-6.1 4.9-8.9-5.5 6.2-5.2z m-12.9-0.6l6.7 4 4.1-3.2-6.6-4.4z' })
        )
    );
};

exports.default = IoSocialDropboxOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-dropbox-outline.js
// module id = 2433
// module chunks = 0